import { cx } from '@platform/core/lib/cx';
import { useGetStatsQuery } from '@platform/state/api';
import type { IDesignSubPillProps } from './IDesignSubPillProps';

/**
 * Вкладка-пігулка розділу проєктування (прототип v4 dsgSubs): підпис і лічильник записів вкладки (статистика з її фільтром); активна —
 * акцентна з напівпрозорим лічильником.
 */
export function DesignSubPill({ ws, rt, label, filter, active, onSelect }: IDesignSubPillProps) {
  const { data } = useGetStatsQuery({ ws, rt, by: 'status', params: { filter } }, { skip: !rt });
  return (
    <button type="button" role="tab" aria-selected={active} className={cx('dsg-pill', active && 'is-on')} onClick={onSelect}>
      {label}
      <span className="dsg-pill__n">{data ? data.total : '…'}</span>
    </button>
  );
}
